import { GenericAutoCompleteFunctions } from "./generic-autocomplete-functions";

export class GenericAutoCompleteView<T> extends GenericAutoCompleteFunctions<T> {
    async onClickOptionsList() {
        let res = await this.OnClickOptionsList();
        return res;
    }
}